export default {
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  computed: {
    navStyle() {
      return {
        position: "fixed",
        top: "0",
        left: "50%",
        transform: `translateX(-50%) scale(${this.scale})`,
        transformOrigin: "center top",
        width: "1920px",
        zIndex: 9999
      };
    }
  },
  data() {
    return {};
  },
  methods: {
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};